import React, { useEffect, useState } from "react";
import FontIcon from "react-md/lib/FontIcons";
import "../styles/expandableTable.css";
import NoRecordsIcon from "../../../../../assets/icons/no-records.png";
import { Button } from "react-md";
import filterApplied from "../../../../../assets/icons/filter-applied-icon.svg";
import funnelIcon from "../../../../../assets/icons/funnel.svg";
import goIcon from "../../../../../assets/icons/right_arrow_go_btn.svg";
import {
  TextField,
  MenuItem,
  Menu,
  IconButton,
  Radio,
} from "@material-ui/core";

const ExpandableTable = (props) => {
  const [expandedRowId, setExpandedRowId] = useState(null); // state to track expanded row
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuFor, setMenuFor] = useState({});
  const [tableData, setTableData] = useState(
    props?.data?.assignedServiceProviders
  );
  const [serviceProviderId, setServiceProviderId] = useState("");
  const [filterObj, setFilterObj] = useState({});
  const [openFilter, setOpenFilter] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log("props recvd in expandabel table: ", props);
  }, []);

  useEffect(() => {
    setTableData(props?.data?.assignedServiceProviders);
    console.log("props recvd in expandabel table: ", props);
  }, [props]);

  useEffect(() => {
    // props.fetchAssignedServiceProvidersByFilter(
    //   props?.data?.planData?.id ?? -1,
    //   filterObj
    // );

    props.fetchAssignedServiceProvidersByFilter({
      pageNum: props?.pageNum,
      pageSize: props?.pageSize,
      serviceIds: [props?.data?.service?.id ? props?.data?.service?.id : 0],
      // serviceProviderIds: [],
      ...filterObj,
    });
    console.log("props recvd in expandabel table: ", props);
  }, [filterObj]);

  const STATUS_MAP = {
    Active: "active",
    Inactive: "inactive",
  };

  const handleRowClick = (id) => {
    setExpandedRowId(expandedRowId === id ? null : id); // toggle expansion
  };
  const handleMoreClick = (event, serviceProvider) => {
    setAnchorEl(event.currentTarget);
    setMenuFor(serviceProvider);
  };

  const handleEditServiceProviders = (ele, opt) => {
    console.log("ni ,  In expanadable tile  -> ", ele);
    if (opt == 1) {
      props.setView(6, {
        mode: "view",
        service: props?.data?.service,
        serviceProvider: ele,
      });
    } else if (opt == 2) {
      props.setView(6, {
        mode: "update",
        service: props?.data?.service,
        serviceProvider: ele,
      });
    }
  };

  const stringToInt = (str) => {
    const num = parseInt(str, 10); // Convert string to integer with base 10
    return isNaN(num) ? null : num; // Check if conversion failed
  };

  return (
    <div className="table-container">
      <table className="expandable-table">
        <thead>
          <tr>
            <th>
              Service provider ID
              <img
                src={
                  (filterObj?.serviceProviderIds?.length ?? 0) > 0
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(2);
                }}
              />
              {openFilter === 2 && (
                <div className="filter-div-assigned-plans-table">
                  <div className="can-be-booked-for-filter">
                    <TextField
                      placeholder="Service ID"
                      type="text"
                      value={serviceProviderId}
                      onChange={(e) => {
                        setServiceProviderId(e.target.value);
                        if (e.target.value == "") {
                          setFilterObj((prev) => ({
                            ...prev,
                            serviceProviderIds: [],
                          }));
                        }
                      }}
                    />

                    <img
                      src={goIcon}
                      alt="Go"
                      style={{
                        width: "20px",
                        height: "20px",
                        cursor: "pointer",
                        marginBottom: "-10px",
                      }}
                      onClick={() => {
                        setFilterObj((prev) => ({
                          ...prev,
                          serviceProviderIds: [stringToInt(serviceProviderId)],
                        }));
                      }}
                    />
                    {/* <Button
                      className="clear-navigo-booked-for"
                      onClick={() => {
                        setFilterObj((prev) => ({ ...prev, status: null }));
                      }}
                    >
                      Clear
                    </Button> */}
                  </div>
                </div>
              )}
            </th>
            <th>Name</th>
            <th>Mode</th>
            <th>Cost price (Rs)</th>
            <th>
              Status
              <img
                className="filter-icon-assigned-plans"
                src={filterObj?.serviceModeStatus ? filterApplied : funnelIcon}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(1);
                }}
              />
              {openFilter === 1 && (
                <div className="filter-div-assigned-plans-table">
                  <div className="can-be-booked-for-filter">
                    {Object.entries(STATUS_MAP).map(([key, val]) => (
                      <div>
                        <Radio
                          label={key}
                          checked={filterObj?.serviceModeStatus == val}
                          onClick={() => {
                            setOpenBackdrop(false);
                            setOpenFilter(-1);
                            setFilterObj((prev) => ({
                              ...prev,
                              serviceModeStatus: val,
                            }));
                          }}
                        />
                        <label className="label-radio-btn">{key}</label>
                      </div>
                    ))}
                    <Button
                      className="clear-navigo-booked-for"
                      onClick={() => {
                        setFilterObj((prev) => ({
                          ...prev,
                          serviceModeStatus: null,
                        }));
                      }}
                    >
                      Clear
                    </Button>
                  </div>
                </div>
              )}
            </th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody className="animated-box">
          {Boolean(tableData?.length == null || tableData?.length <= 0) && (
            <tr>
              <td colSpan={5}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 40,
                  }}
                >
                  <div
                    style={{ textAlign: "center", fontFamily: "Montserrat" }}
                  >
                    No service provider is assigned to this service yet.
                  </div>
                  <div style={{ height: "16px" }}></div>
                  <img src={NoRecordsIcon} width={50} height={62} />
                </div>
              </td>
            </tr>
          )}

          {tableData && tableData.length > 0 && (
            <tr>
              <td />
              <td />
              <td />
              <td />
              <td />
              <td
                colSpan={3}
                align="right"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <Button
                  onClick={() => {
                    props.goToPrevPage();
                  }}
                  disabled={props?.pageNum <= 1 || loading}
                >
                  <FontIcon className="navigo-count-icon">arrow_left</FontIcon>
                </Button>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  Showing&nbsp;
                  <span
                    style={{
                      color: "#ef7c01",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    {(props?.pageNum - 1) * props?.pageSize + 1}&nbsp;
                  </span>
                  <span
                    style={{
                      color: "#ef7c01",
                    }}
                  >
                    -
                  </span>
                  <span
                    style={{
                      color: "#ef7c01",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    &nbsp;
                    {props?.totalCount > props?.pageNum * props?.pageSize
                      ? props?.pageNum * props?.pageSize
                      : props?.totalCount}
                  </span>
                  <span>&nbsp;&nbsp;of&nbsp;</span>
                  <span>{` ${props?.totalCount}`}</span>
                </div>
                <Button
                  onClick={() => {
                    props.goToNextPage();
                  }}
                  disabled={
                    loading ||
                    props?.pageNum * props?.pageSize > props?.totalCount ||
                    (props?.totalCount > props?.pageNum * props?.pageSize
                      ? props?.pageNum * props?.pageSize
                      : props?.totalCount) == props?.totalCount
                  }
                >
                  <FontIcon>arrow_right</FontIcon>
                </Button>
              </td>
            </tr>
          )}

          {tableData.map((row, index) => (
            <React.Fragment key={index}>
              <tr
                // onClick={() => handleRowClick(row?.serviceProviderId)}
                className={`${index > 0 ? "table-row-border" : ""}`}
              >
                <td>{row?.serviceProviderId}</td>
                <td>{row?.serviceProviderName}</td>
                <td>{row?.serviceModes?.[0]?.mode}</td>
                <td>{row?.serviceModes?.[0]?.price}</td>
                <td>
                  {row?.serviceModes?.[0]?.modeStatus != null && (
                    <div
                      className={`${
                        row?.serviceModes?.[0]?.modeStatus
                          ? "navigo-appoint-non-select-status-active"
                          : "navigo-appoint-non-select-status-inactive"
                      } `}
                    >
                      <span>
                        {row?.serviceModes?.[0]?.modeStatus
                          ? "Active"
                          : "Inactive"}
                      </span>
                    </div>
                  )}
                </td>
                <td />
                <td>
                  <FontIcon
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleMoreClick(e, row)}
                  >
                    more_vert
                  </FontIcon>
                </td>
              </tr>
              {row?.serviceModes?.slice(1)?.map((row, index) => (
                <tr key={index} className="table-row-expanded animated-box">
                  <td></td>
                  <td></td>
                  <td>{row?.mode}</td>
                  <td>{row?.price}</td>
                  <td>
                    {row?.modeStatus != null && (
                      <div
                        className={`${
                          row?.modeStatus
                            ? "navigo-appoint-non-select-status-active"
                            : "navigo-appoint-non-select-status-inactive"
                        } `}
                      >
                        <span>{row?.modeStatus ? "Active" : "Inactive"}</span>
                      </div>
                    )}
                    <td />
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => {
          setAnchorEl(null);
          setMenuFor(null);
        }}
      >
        <MenuItem
          onClick={() => {
            handleEditServiceProviders(menuFor, 2);
            setAnchorEl(null);
          }}
        >
          Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleEditServiceProviders(menuFor, 1);
            setAnchorEl(null);
          }}
        >
          View
        </MenuItem>
      </Menu>

      {openBackdrop && (
        <div
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            width: "100vw",
            height: "100vh",
          }}
          onClick={() => {
            setOpenFilter(-1);
            setOpenBackdrop(false);
          }}
        ></div>
      )}
    </div>
  );
};

export default ExpandableTable;
